import axios from "axios";
import { SwaggerJsonFile } from "models/apiDocumentation/apiDocumentationModels";
import featureFlags from "utils/featureFlags";

export const getSwaggerJsonFile = async (): Promise<SwaggerJsonFile> => {
  const data = await axios
    .get(`${process.env.REACT_APP_API_SWAGGER_FILE}`, {
      responseType: "json",
    })
    .then((response) => response.data);
  return data;
};

export const getNoSqlSwaggerJsonFile =
  async (): Promise<SwaggerJsonFile | null> => {
    if (featureFlags.disableNoSqlApi) {
      return null;
    }
    const noSqlData = await axios
      .get(`${process.env.REACT_APP_NOSQL_API_SWAGGER_FILE}`, {
        responseType: "json",
      })
      .then((response) => response.data);
    return noSqlData;
  };
